// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/blit.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'blitPixelShader';
const shader = `#ifdef GL_ES
#endif
precision highp float;
varying vec2 vUV;
uniform sampler2D textureSampler;
void main(void)
{
vec4 currentFramePixelValue = texture2D(textureSampler, vUV);
gl_FragColor = currentFramePixelValue;
}
`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const blitPixelShader = { name, shader };
//# sourceMappingURL=blit.fragment.js.map